var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeakerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000A19",
    fillRule: "evenodd",
    d: "M21.894 5.553a1 1 0 0 1-.447 1.341l-2 1a1 1 0 1 1-.894-1.788l2-1a1 1 0 0 1 1.341.447Zm-5.368-.404A1 1 0 0 1 17 6v11a1 1 0 0 1-1.447.894l-3.866-1.932-3.023-.504-1.472 4.168a2.06 2.06 0 0 1-3.973-1.024l.63-3.78c.012-.072.028-.142.046-.211A3.5 3.5 0 0 1 5.5 8h.417l5.77-.962 3.866-1.932a1 1 0 0 1 .973.043ZM11 9.18l-4 .667v3.306l1.145.19.036.007 2.819.47V9.18Zm2 5.202 2 1V7.618l-2 1v5.764Zm-8-1.467v-2.83a1.5 1.5 0 0 0 0 2.83Zm.954 2.091.707.118-1.355 3.836a.06.06 0 0 1-.114-.03l.63-3.78a.18.18 0 0 1 .132-.144ZM18 11a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2h-2a1 1 0 0 1-1-1Zm.106 3.553a1 1 0 0 1 1.341-.448l2 1a1 1 0 0 1-.894 1.79l-2-1a1 1 0 0 1-.447-1.342Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakerIcon);
export default __webpack_public_path__ + "static/media/speaker-icon.9463be094e4838bc5b9a3a106233fb48.svg";
export { ForwardRef as ReactComponent };